import Vue from 'vue'

export const getReports = async () => Vue.prototype.$httpReport.get('reports')

export const generateReport = async ({ date }) => Vue.prototype.$httpReport.post('generate-report', { date })
console.log(generateReport)

export const downloadReport = async ({ filename }) => Vue.prototype.$httpReport.get('download-report/' + filename)
